export const userLoaded = (user) => {
    return {
        type: 'USER_LOADED',
        payload: user,
    };
};
